import {RENDER_SUBMIT_BUTTON, HIDE_SUBMIT_BUTTON} from '../constants'

export default (state = {renderSubmitButton: false}, action = {}) => {
  switch (action.type) {
    case RENDER_SUBMIT_BUTTON:
      return {renderSubmitButton: true}
    case HIDE_SUBMIT_BUTTON:
      return {renderSubmitButton: false}
    default:
      return state
  }
}
